"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const embla_carousel_1 = __importDefault(require("embla-carousel"));
const Navigation_1 = require("@web/common/embla/Navigation");
const Pager_1 = require("@web/common/embla/Pager");
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
embla_carousel_1.default.globalOptions = {
    align: 'start',
};
function buildEmblaCarousel(emblaElement, runOnSmallScreenOnly) {
    let embla = null;
    let initEmblaOnResizeFinished;
    function createEmbla() {
        if (embla !== null) {
            return;
        }
        const viewportElement = emblaElement.querySelector('.embla-viewport');
        const pagerElement = emblaElement.querySelector('.embla-dots');
        const navigationElement = emblaElement.querySelector('.embla-buttons');
        if (viewportElement === null) {
            return;
        }
        embla = (0, embla_carousel_1.default)(viewportElement);
        embla.on('init', () => {
            viewportElement.classList.add('embla-active');
        });
        embla.on('destroy', () => {
            viewportElement.classList.remove('embla-active');
        });
        if (navigationElement !== null) {
            (0, Navigation_1.addNavigation)(embla, navigationElement);
            embla.on('destroy', (0, Navigation_1.removeNavigation)(navigationElement));
        }
        if (pagerElement !== null) {
            (0, Pager_1.addPager)(embla, pagerElement);
            embla.on('destroy', (0, Pager_1.removePager)(pagerElement));
        }
    }
    function destroyEmbla() {
        if (embla === null) {
            return;
        }
        embla.destroy();
        embla = null;
    }
    function initEmbla() {
        if (runOnSmallScreenOnly === true) {
            if (ScreenSize_1.default.isSmallScreen()) {
                createEmbla();
            }
            else {
                destroyEmbla();
            }
        }
        else {
            createEmbla();
        }
    }
    initEmbla();
    window.addEventListener('resize', () => {
        clearTimeout(initEmblaOnResizeFinished);
        initEmblaOnResizeFinished = setTimeout(initEmbla, 200);
    });
}
(() => {
    const emblaCarouselElements = Array.from(document.querySelectorAll('*[data-component-name="embla-carousel"]'));
    emblaCarouselElements.forEach((emblaCarouselElement) => {
        const runOnSmallScreenOnly = emblaCarouselElement.dataset.runOnSmallScreenOnly === 'true';
        buildEmblaCarousel(emblaCarouselElement, runOnSmallScreenOnly);
    });
})();
